import React from 'react'
import {
  Grid,
  Col,
  Row,
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
} from 'react-bootstrap'
import {
  CFXProFormatNumber,
  CalculatorCol,
  FormattedDate,
} from '../../helpers/formatting'
import {connect} from 'react-redux'
import {defaultNumbersFor} from '../../helpers/defaultNumbers'
import {HEIFER_INDEX, STEER_INDEX, REGEX} from '../../constants'
import {
  hedgeablePrice,
  profitLoss,
  breakevenPP,
  breakevenBasis,
  breakevenCDN,
  breakevenFutures,
  costOfGainPerCWT,
  finishingProductionCostPerHead,
  breakevenTotalCostPerHead,
  breakevenPricePerCWT,
  finishingBarleyCostPerHead,
  finishingSilagePerHead,
  finishingSilageCost,
  finishingSupplementCostPerHead,
  finishingTotalCostPerHead,
  finishingSaleDate,
} from '../../helpers/calculators/finishingCalculations'
import {feedValuesClosestToDate} from '../../helpers/calculators/sharedCalculations'
import {saveFinishing, updateFinishing, replaceAllDefaults} from '../../actions'
import {withRouter} from 'react-router'
import CFXProReactCollapsible from '../cfxProReactCollapsible'
import {buildLastUpdateFooter} from '../../helpers/textbuilders'
import {parseApiStringDateToDate} from '../../helpers/feedParser'
import api from '../../api'
import * as at from '../../actionTypes'
import {updateDefaultNumbers} from '../../reducers'
import {SyncableButton} from '../../helpers/button'
import {syncDefaultNumbers, syncUserData} from '../../helpers/syncing'
import _ from 'lodash'

var finishingSavedDefaultsTimeout

@api
@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {finishings, userId},
    data: {dtn, basis},
    defaultNumbers,
  } = state

  return {
    finishings,
    defaultNumbers,
    dtnFeedData: dtn,
    basisValues: basis,
    isLoggedIn,
    userId,
  }
})
class FinishingCalculator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: 0,
      purchaseDate: '',
      inWeight: '',
      purchasePricePerLb: '',
      isActive: true,
      syncingFinishing: false,
      syncingDefaults: false,
      didSaveDefaults: false,
      // Deep Copy the object in full
      localDefaultNumbers: JSON.parse(
        JSON.stringify(this.props.defaultNumbers),
      ),
    }
  }

  componentWillMount() {
    const {
      match: {
        params: {id = null},
      },
      finishings,
    } = this.props

    if (id && finishings[id]) {
      const {type, purchaseDate, inWeight, purchasePricePerLb} = finishings[id]
      this.setState({
        type,
        purchaseDate,
        inWeight,
        purchasePricePerLb,
      })
    }
  }

  onValueChanged = (id, value, sender = null) => {
    if (_.includes(id, 'Date')) {
      value = FormattedDate(value)
    }
    if (id in this.state) {
      this.setState({[id]: value})
    } else {
      if (sender != null && !sender.target.validity.valid) {
        return
      }

      const {localDefaultNumbers, type, inWeight} = this.state
      const newDefaultNumbers = updateDefaultNumbers(localDefaultNumbers, {
        type: at.FINISHING_UPDATE_DEFAULT_NUMBER,
        payload: {
          data: {
            key: id,
            value,
            type: type === HEIFER_INDEX ? 'heifer' : 'steer',
            inWeight,
          },
        },
      })

      this.setState({localDefaultNumbers: newDefaultNumbers})
    }
  }

  calculate(defaults, finishing) {
    const {localDefaultNumbers} = this.state
    const {dtnFeedData, basisValues} = this.props

    if (
      !this.isFilledfinishing(finishing) ||
      dtnFeedData == null ||
      basisValues == null ||
      localDefaultNumbers == null
    ) {
      return {
        hedgeablePrice: '',
        profitLoss: '',
        breakevenPP: '',
        breakevenBasis: '',
        breakevenCDN: '',
        breakevenFutures: '',
        costOfGain: '',
        prodCostPerHead: '',
        totalCostPerHead: '',
        breakevenPricePerCWT: '',
        barleyCostPerHead: '',
        silageCostPerHead: '',
        supplementCostPerHead: '',
        finishingTotalCostPerHead: '',
      }
    }

    return {
      hedgeablePrice: hedgeablePrice(
        defaults,
        finishing,
        dtnFeedData,
        basisValues,
      ),
      profitLoss: profitLoss(defaults, finishing, dtnFeedData, basisValues),
      breakevenPP: breakevenPP(defaults, finishing, dtnFeedData, basisValues),
      breakevenBasis: breakevenBasis(
        defaults,
        finishing,
        dtnFeedData,
        basisValues,
      ),
      breakevenCDN: breakevenCDN(defaults, finishing, dtnFeedData, basisValues),
      breakevenFutures: breakevenFutures(
        defaults,
        finishing,
        dtnFeedData,
        basisValues,
      ),
      costOfGain: costOfGainPerCWT(
        defaults,
        finishing,
        dtnFeedData,
        basisValues,
      ),
      prodCostPerHead: finishingProductionCostPerHead(defaults, finishing),
      breakevenTotalCostPerHead: breakevenTotalCostPerHead(defaults, finishing),
      breakevenPricePerCWT: breakevenPricePerCWT(defaults, finishing),
      barleyCostPerHead: finishingBarleyCostPerHead(defaults, finishing),
      silageCostPerHead: finishingSilagePerHead(defaults, finishing),
      supplementCostPerHead: finishingSupplementCostPerHead(
        defaults,
        finishing,
      ),
      finishingTotalCostPerHead: finishingTotalCostPerHead(defaults, finishing),
    }
  }

  localSaveFinishing() {
    const finishing = Object.assign({}, this.state)

    if (!this.isFilledfinishing(finishing)) {
      alert('Please fill out all fields!')
      return
    }

    const {
      isLoggedIn,
      finishings,
      userId,
      apiInstance,
      dispatch,
      history,
      match: {
        params: {id = null},
      },
    } = this.props

    const defaults = this.defaultsForFinishing(finishing)
    const calcValues = this.calculate(defaults, finishing)

    const fullFinishing = {
      id: id === null ? this.nextId(finishings) : id,
      ...finishing,
      ...calcValues,
    }

    // Temp value to ensure we don't sync the defaults unless the user saves them
    delete fullFinishing['syncingFinishing']
    delete fullFinishing['syncingDefaults']
    delete fullFinishing['didSaveDefaults']
    delete fullFinishing['localDefaultNumbers']

    if (isLoggedIn) {
      fullFinishing.userId = userId
      this.setState({syncingFinishing: true})
      syncUserData(apiInstance, fullFinishing, dispatch, 'Finishing')
        .then((response) => {
          this.setState({syncingFinishing: false})
          history.push('/breakeven/finishing')
        })
        .catch((err) => {
          this.setState({syncingFinishing: false})
        })
    } else {
      this.updateReduxWithFinishing(fullFinishing)
    }
  }

  updateReduxWithFinishing(fullFinishing) {
    const {
      dispatch,
      history,
      match: {
        params: {id = null},
      },
    } = this.props

    if (id === null) {
      dispatch(saveFinishing(fullFinishing))
    } else {
      dispatch(updateFinishing(fullFinishing))
    }
    history.push('/breakeven/finishing')
  }

  localSaveDefaults = () => {
    const {localDefaultNumbers} = this.state
    const {isLoggedIn, apiInstance, userId} = this.props

    if (isLoggedIn) {
      localDefaultNumbers.userId = userId
      this.setState({syncingDefaults: true})
      syncDefaultNumbers(apiInstance, localDefaultNumbers)
        .then((response) => {
          this.updateReduxWithDefaults(localDefaultNumbers)
          this.setState({syncingDefaults: false})
        })
        .catch(() => {
          this.setState({syncingDefaults: false})
        })
    } else {
      this.updateReduxWithDefaults(localDefaultNumbers)
    }
  }

  updateReduxWithDefaults = () => {
    const {localDefaultNumbers} = this.state
    const {dispatch} = this.props
    dispatch(replaceAllDefaults(localDefaultNumbers))
    this.setState({didSaveDefaults: true})
    clearTimeout(finishingSavedDefaultsTimeout)
    finishingSavedDefaultsTimeout = setTimeout(() => {
      this.setState({didSaveDefaults: false})
    }, 2000)
  }

  nextId(finishings) {
    const finishingIds = Object.keys(finishings)

    var lowestfinishingId = -1
    if (finishingIds.length > 0) {
      lowestfinishingId = Math.min(...finishingIds)

      if (lowestfinishingId == null || lowestfinishingId > 0) {
        lowestfinishingId = -1
      } else {
        lowestfinishingId -= 1
      }
    }
    return lowestfinishingId
  }

  isFilledfinishing(finishing) {
    return (
      finishing.purchaseDate !== null &&
      finishing.purchaseDate !== '' &&
      finishing.inWeight !== null &&
      finishing.inWeight !== '' &&
      finishing.purchasePricePerLb !== null &&
      finishing.purchasePricePerLb !== ''
    )
  }

  defaultsForFinishing(finishing) {
    return defaultNumbersFor(
      this.state.localDefaultNumbers,
      'finishing',
      finishing.type === HEIFER_INDEX ? 'heifer' : 'steer',
      finishing.inWeight,
    )
  }

  render() {
    const {
      match: {
        params: {id = null},
      },
      dtnFeedData,
      basisValues,
    } = this.props

    const {didSaveDefaults, syncingDefaults, syncingFinishing} = this.state

    const finishing = Object.assign({}, this.state)
    const defaults = this.defaultsForFinishing(finishing)

    const {
      hedgeablePrice,
      profitLoss,
      breakevenPP,
      breakevenBasis,
      breakevenCDN,
      breakevenFutures,
      costOfGain,
      prodCostPerHead,
      breakevenTotalCostPerHead,
      breakevenPricePerCWT,
      barleyCostPerHead,
      silageCostPerHead,
      supplementCostPerHead,
      finishingTotalCostPerHead,
    } = this.calculate(defaults, finishing)

    const finishDate = finishingSaleDate(defaults, finishing)
    const {liveCattle, cdn} = feedValuesClosestToDate(
      finishDate,
      dtnFeedData,
      basisValues,
    )

    return (
      <div className="cfx-finishing-calculator">
        <Grid>
          <h1 className="text-center">Finishing</h1>
          <FinishingInput
            type={finishing.type}
            purchaseDate={finishing.purchaseDate}
            inWeight={finishing.inWeight}
            purchasePricePerLb={finishing.purchasePricePerLb}
            onValueChanged={this.onValueChanged}
          />
          <CFXProReactCollapsible title="Default Numbers">
            <FinishingDefaultNumbers
              outWeight={defaults.outWeight}
              avgDailyGain={defaults.avgDailyGain}
              barley={defaults.barley}
              silage={defaults.silage}
              supplement={defaults.supplement}
              syncingDefaults={syncingDefaults}
              didSaveDefaults={didSaveDefaults}
              saveDefaults={this.localSaveDefaults}
              onValueChanged={this.onValueChanged}
            />
          </CFXProReactCollapsible>
          <CFXProReactCollapsible title="Results" open={true}>
            <FinishingResults
              hedgeablePrice={hedgeablePrice}
              profitLoss={profitLoss}
              breakevenPP={breakevenPP}
              breakevenBasis={breakevenBasis}
              breakevenCDN={breakevenCDN}
              breakevenFutures={breakevenFutures}
              costOfGain={costOfGain}
            />
          </CFXProReactCollapsible>
          <CFXProReactCollapsible title="Cost and Breakeven Summary">
            <FinishingCostAndBreakevenSummary
              prodCostPerHead={prodCostPerHead}
              costOfGain={costOfGain}
              breakevenTotalCostPerHead={breakevenTotalCostPerHead}
              breakevenPricePerCWT={breakevenPricePerCWT}
            />
          </CFXProReactCollapsible>
          <CFXProReactCollapsible title="Total Cost of Feed">
            <FinishingTotalCostOfFeed
              defaults={defaults}
              silageCost={finishingSilageCost(defaults)}
              barleyCostPerHead={barleyCostPerHead}
              silageCostPerHead={silageCostPerHead}
              supplementCostPerHead={supplementCostPerHead}
              finishingTotalCostPerHead={finishingTotalCostPerHead}
              syncingDefaults={syncingDefaults}
              didSaveDefaults={didSaveDefaults}
              saveDefaults={this.localSaveDefaults}
              onValueChanged={this.onValueChanged}
            />
          </CFXProReactCollapsible>
          <CFXProReactCollapsible title="Other Costs">
            <FinishingOtherCosts
              defaults={defaults}
              syncingDefaults={syncingDefaults}
              didSaveDefaults={didSaveDefaults}
              saveDefaults={this.localSaveDefaults}
              onValueChanged={this.onValueChanged}
            />
          </CFXProReactCollapsible>
          <Row>
            <SyncableButton
              className="cfxpro__btn-default btn btn-default"
              style={{width: '75%', display: 'block', margin: '1em auto'}}
              isSyncing={syncingFinishing}
              isUpdate={id != null}
              baseTitle="Finishing"
              onClick={() => this.localSaveFinishing()}
            />
          </Row>
          <Row>
            <div className="cfx-rt-table">
              <div className="cfx-rt-footer">
                {buildLastUpdateFooter(
                  'LC Futures price is as of (date) at (time)',
                  liveCattle == null
                    ? null
                    : parseApiStringDateToDate(liveCattle.lastUpdated),
                )}
                <br />
                {buildLastUpdateFooter(
                  'CDN $ is as of (date) at (time)',
                  cdn == null
                    ? null
                    : parseApiStringDateToDate(cdn.lastUpdated),
                )}
              </div>
            </div>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default FinishingCalculator

class FinishingInput extends React.Component {
  render() {
    const {
      type,
      purchaseDate,
      inWeight,
      purchasePricePerLb,
      onValueChanged,
    } = this.props

    return (
      <div>
        <Row>
          <Col>
            <ButtonToolbar>
              <ToggleButtonGroup
                id="type"
                type="radio"
                name="options"
                value={type}
                onChange={(e) => onValueChanged('type', e)}
              >
                <ToggleButton value={HEIFER_INDEX}>
                  {type === HEIFER_INDEX && (
                    <i style={{paddingRight: '10px'}} className="fa fa-check" />
                  )}Heifer
                </ToggleButton>
                <ToggleButton value={STEER_INDEX}>
                  {type === STEER_INDEX && (
                    <i style={{paddingRight: '10px'}} className="fa fa-check" />
                  )}Steer
                </ToggleButton>
              </ToggleButtonGroup>
            </ButtonToolbar>
          </Col>
        </Row>
        <Row style={{padding: '10px 0'}}>
          <CalculatorCol
            id="purchaseDate"
            type="date"
            label="Purchase Date"
            placeholder="yyyy-mm-dd"
            value={purchaseDate}
            max="9999-12-31"
            onChange={(e) => onValueChanged('purchaseDate', e.target.value)}
          />
          <CalculatorCol
            id="inWeight"
            type="number"
            label="In Weight"
            placeholder="lbs"
            value={inWeight}
            onChange={(e) => onValueChanged('inWeight', e.target.value)}
          />
          <CalculatorCol
            id="purchasePricePerLb"
            type="number"
            label="Purchase Price Per lb"
            placeholder="$"
            value={purchasePricePerLb}
            onChange={(e) =>
              onValueChanged('purchasePricePerLb', e.target.value)
            }
          />
        </Row>
      </div>
    )
  }
}

class FinishingDefaultNumbers extends React.Component {
  render() {
    const {
      outWeight = null,
      avgDailyGain = null,
      barley = null,
      silage = null,
      supplement = null,
      syncingDefaults,
      didSaveDefaults,
      saveDefaults,
      onValueChanged,
    } = this.props

    return (
      <div>
        <Row>
          <CalculatorCol
            id="outWeight"
            type="text"
            label="Out Weight"
            value={outWeight === null ? 'N/A' : outWeight}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('outWeight', e.target.value, e)}
            disabled={outWeight === null}
          />
          <CalculatorCol
            id="avgDailyGain"
            type="text"
            label="Avg. Daily Gain"
            value={avgDailyGain === null ? 'N/A' : avgDailyGain}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('avgDailyGain', e.target.value, e)}
            disabled={avgDailyGain === null}
          />
          <CalculatorCol
            id="barley"
            type="text"
            label="Barley lbs/Head"
            value={barley === null ? 'N/A' : barley}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('barley', e.target.value, e)}
            disabled={barley === null}
          />
          <CalculatorCol
            id="silage"
            type="text"
            label="Silage lbs/Head"
            value={silage === null ? 'N/A' : silage}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('silage', e.target.value, e)}
            disabled={silage === null}
          />
          <CalculatorCol
            id="supplement"
            type="text"
            label="Supplement lbs/Head"
            value={supplement === null ? 'N/A' : supplement}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('supplement', e.target.value, e)}
            disabled={supplement === null}
          />
        </Row>
        <Row>
          <SyncableButton
            className="cfxpro__btn-default btn btn-default"
            style={{width: '75%', display: 'block', margin: '1em auto'}}
            isSyncing={syncingDefaults}
            didSync={didSaveDefaults}
            baseTitle="Default Numbers"
            onClick={(e) => saveDefaults()}
          />
        </Row>
      </div>
    )
  }
}

class FinishingResults extends React.Component {
  render() {
    const {
      hedgeablePrice,
      profitLoss,
      breakevenPP,
      breakevenBasis,
      breakevenCDN,
      breakevenFutures,
      costOfGain,
    } = this.props

    return (
      <Row>
        <CalculatorCol
          id="hedgeablePrice"
          type="text"
          label="Hedgeable Price"
          value={CFXProFormatNumber(hedgeablePrice)}
          disabled={true}
        />
        <CalculatorCol
          id="profitLoss"
          type="text"
          label="Profit/Loss"
          value={CFXProFormatNumber(profitLoss)}
          disabled={true}
        />
        <CalculatorCol
          id="breakevenPP"
          type="text"
          label="Breakeven PP"
          value={CFXProFormatNumber(breakevenPP)}
          disabled={true}
        />
        <CalculatorCol
          id="breakevenBasis"
          type="text"
          label="Breakeven Basis"
          value={CFXProFormatNumber(breakevenBasis)}
          disabled={true}
        />
        <CalculatorCol
          id="breakevenCDN"
          type="text"
          label="Breakeven CDN $"
          value={CFXProFormatNumber(breakevenCDN)}
          disabled={true}
        />
        <CalculatorCol
          id="breakevenFutures"
          type="text"
          label="Breakeven Futures"
          value={CFXProFormatNumber(breakevenFutures)}
          disabled={true}
        />
        <CalculatorCol
          id="costOfGain"
          type="text"
          label="Cost of Gain $/lb"
          value={CFXProFormatNumber(costOfGain)}
          disabled={true}
        />
      </Row>
    )
  }
}

class FinishingCostAndBreakevenSummary extends React.Component {
  render() {
    const {
      prodCostPerHead,
      costOfGain,
      breakevenTotalCostPerHead,
      breakevenPricePerCWT,
    } = this.props

    return (
      <Row>
        <CalculatorCol
          id="prodCostPerHead"
          type="text"
          label="Prod Cost $/head"
          value={CFXProFormatNumber(prodCostPerHead)}
          disabled={true}
        />
        <CalculatorCol
          id="costOfGainPerCWT"
          type="text"
          label="COG $/cwt"
          value={CFXProFormatNumber(costOfGain)}
          disabled={true}
        />
        <CalculatorCol
          id="breakevenTotalCostPerHead"
          type="text"
          label="Total Cost $/head"
          value={CFXProFormatNumber(breakevenTotalCostPerHead)}
          disabled={true}
        />
        <CalculatorCol
          id="breakevenPricePerCWT"
          type="text"
          label="BE Price $/cwt"
          value={CFXProFormatNumber(breakevenPricePerCWT)}
          disabled={true}
        />
      </Row>
    )
  }
}

class FinishingTotalCostOfFeed extends React.Component {
  render() {
    const {
      defaults,
      defaults: {
        barleyCost = null,
        supplementCost = null,
        barley = null,
        silage = null,
        supplement = null,
      },
      barleyCostPerHead,
      silageCost,
      silageCostPerHead,
      supplementCostPerHead,
      finishingTotalCostPerHead,
      syncingDefaults,
      didSaveDefaults,
      saveDefaults,
      onValueChanged,
    } = this.props

    var formattedSilageCost = silageCost
    if (defaults.silageCost === null) {
      formattedSilageCost = CFXProFormatNumber(silageCost)
    }

    return (
      <div>
        <Row>
          <CalculatorCol
            id="barleyCost"
            type="text"
            label="Barley Cost $/Tonne"
            value={barleyCost === null ? 'N/A' : barleyCost}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('barleyCost', e.target.value, e)}
            disabled={barleyCost === null}
          />
          <CalculatorCol
            id="supplementCost"
            type="text"
            label="Supplement Cost $/Tonne"
            value={supplementCost === null ? 'N/A' : supplementCost}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('supplementCost', e.target.value, e)
            }
            disabled={supplementCost === null}
          />
          <CalculatorCol
            id="silageCost"
            type="text"
            label="Silage $/Tonne = Barley $/Bushel x 12.5"
            value={formattedSilageCost === null ? 'N/A' : formattedSilageCost}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('silageCost', e.target.value, e)}
            disabled={silageCost === null}
          />
          <CalculatorCol
            id="barleyCostPerHead"
            type="text"
            label="Barley $/Head"
            value={CFXProFormatNumber(barleyCostPerHead)}
            disabled={true}
          />
          <CalculatorCol
            id="silageCostPerHead"
            type="text"
            label="Silage $/Head"
            value={CFXProFormatNumber(silageCostPerHead)}
            disabled={true}
          />
          <CalculatorCol
            id="supplementCostPerHead"
            type="text"
            label="Supplement $/Head"
            value={CFXProFormatNumber(supplementCostPerHead)}
            disabled={true}
          />
          <CalculatorCol
            id="finishingTotalCostPerHead"
            type="text"
            label="Total"
            value={CFXProFormatNumber(finishingTotalCostPerHead)}
            disabled={true}
          />
          <CalculatorCol
            id="barley"
            type="text"
            label="Barley lbs/hd/day"
            value={barley === null ? 'N/A' : barley}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('barley', e.target.value, e)}
            disabled={barley === null}
          />
          <CalculatorCol
            id="silage"
            type="text"
            label="Silage lbs/hd/day"
            value={silage === null ? 'N/A' : silage}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('silage', e.target.value, e)}
            disabled={silage === null}
          />
          <CalculatorCol
            id="supplement"
            type="text"
            label="Supplement lbs/hd/day"
            value={supplement === null ? 'N/A' : supplement}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('supplement', e.target.value, e)}
            disabled={supplement === null}
          />
          <CalculatorCol
            id="totalLbsPerHeadPerDay"
            type="text"
            label="Total lbs/hd/day"
            value={CFXProFormatNumber(
              Number(barley) + Number(silage) + Number(supplement),
              2,
            )}
            disabled={true}
          />
        </Row>
        <Row>
          <SyncableButton
            className="cfxpro__btn-default btn btn-default"
            style={{width: '75%', display: 'block', margin: '1em auto'}}
            isSyncing={syncingDefaults}
            didSync={didSaveDefaults}
            baseTitle="Default Numbers"
            onClick={(e) => saveDefaults()}
          />
        </Row>
      </div>
    )
  }
}

class FinishingOtherCosts extends React.Component {
  render() {
    const {
      defaults: {
        truckingInPerHead = null,
        marketingPerHead = null,
        yardagePerDay = null,
        vetAndMedPerHead = null,
        deathLossPerHead = null,
        beddingPerHead = null,
        interestPerHead = null,
      },
      syncingDefaults,
      didSaveDefaults,
      saveDefaults,
      onValueChanged,
    } = this.props

    return (
      <div>
        <Row>
          <CalculatorCol
            id="truckingInPerHead"
            type="text"
            label="Trucking $/head"
            value={truckingInPerHead === null ? 'N/A' : truckingInPerHead}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('truckingInPerHead', e.target.value, e)
            }
            disabled={truckingInPerHead === null}
          />
          <CalculatorCol
            id="marketingPerHead"
            type="text"
            label="Marketing $/head"
            value={marketingPerHead === null ? 'N/A' : marketingPerHead}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('marketingPerHead', e.target.value, e)
            }
            disabled={marketingPerHead === null}
          />
          <CalculatorCol
            id="yardagePerDay"
            type="text"
            label="Yardage $/day"
            value={yardagePerDay === null ? 'N/A' : yardagePerDay}
            pattern={REGEX.float}
            onChange={(e) => onValueChanged('yardagePerDay', e.target.value, e)}
            disabled={yardagePerDay === null}
          />
          <CalculatorCol
            id="vetAndMedPerHead"
            type="text"
            label="Vet & Med $/head"
            value={vetAndMedPerHead === null ? 'N/A' : vetAndMedPerHead}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('vetAndMedPerHead', e.target.value, e)
            }
            disabled={vetAndMedPerHead === null}
          />
          <CalculatorCol
            id="deathLossPerHead"
            type="text"
            label="Death Loss $/head"
            value={deathLossPerHead === null ? 'N/A' : deathLossPerHead}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('deathLossPerHead', e.target.value, e)
            }
            disabled={deathLossPerHead === null}
          />
          <CalculatorCol
            id="beddingPerHead"
            type="text"
            label="Bedding $/head"
            value={beddingPerHead === null ? 'N/A' : beddingPerHead}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('beddingPerHead', e.target.value, e)
            }
            disabled={beddingPerHead === null}
          />
          <CalculatorCol
            id="interestPerHead"
            type="text"
            label="Interest $/head"
            value={interestPerHead === null ? 'N/A' : interestPerHead}
            pattern={REGEX.float}
            onChange={(e) =>
              onValueChanged('interestPerHead', e.target.value, e)
            }
            disabled={interestPerHead === null}
          />
        </Row>
        <Row>
          <SyncableButton
            className="cfxpro__btn-default btn btn-default"
            style={{width: '75%', display: 'block', margin: '1em auto'}}
            isSyncing={syncingDefaults}
            didSync={didSaveDefaults}
            baseTitle="Default Numbers"
            onClick={(e) => saveDefaults()}
          />
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/breakeven/finishingCalculator.js